window.dtEmployeePosition = function () {
  const dtEmployeePosition = new DataTable('#employee-position-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#employee-position-datatable').data('source'),
      beforeSend: function () { showLoadingRow('#employee-position-datatable', 3); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[1, 'desc'], [0, 'asc']],
    columns: [
      { data: "index" },
      { data: "status" },
      { data: "name" }
    ],
    columnDefs: [],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row) {
      $('td', row).addClass('py-1');
    }
  });

  dtFinalTouch();
  return dtEmployeePosition;
}
